import { createLaunchDarklyHelpers } from '@helpers';
import { LDClient } from 'launchdarkly-js-client-sdk';

export function useLaunchDarkly() {
  const { $ldClient } = useNuxtApp();

  return createLaunchDarklyHelpers($ldClient as LDClient);
}
